import {
  useStyle 
} from "@/classify"
import {
  Fragment 
} from "react"
import defaultClasses from "./boolean.module.css"

const Boolean = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const {
    attribute_metadata = {}, selected_attribute_options = {} 
  } = props

  const attributeLabel = attribute_metadata.label ? (
    <div className={classes.label}>{attribute_metadata.label}</div>
  ) : null
  let attributeContent

  if (selected_attribute_options.attribute_option?.length > 0) {
    const options = selected_attribute_options.attribute_option
      .map((option) => option.label)
      .join(", ")

    attributeContent = <div className={classes.content}>{options}</div>
  }

  return (
    <Fragment>
      {attributeLabel}
      {attributeContent}
    </Fragment>
  )
}

export default Boolean
